/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Field_Message_LabelInputs */

const en_contact_field_message_label = /** @type {(inputs: Contact_Field_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What would you like to cover?`)
};

/**
* | output |
* | --- |
* | "What would you like to cover?" |
*
* @param {Contact_Field_Message_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_field_message_label = /** @type {((inputs?: Contact_Field_Message_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Field_Message_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_field_message_label(inputs)
});